import React from 'react'
import { LayoutWithStandardHeader } from 'stylist'
import MainHeader from 'components/MainHeader'
import MainFooter from 'components/MainFooter'
import { Route, Switch, Redirect } from 'react-router-dom'
import RouteLoggedOut from 'routes/logged-out'
import RouteVideo from 'routes/video'
import RouteVideos from 'routes/videos'
import RouteRedirect from 'routes/redirect'
import EnsureSession from 'components/EnsureSession'

const RouteApp = ({ match: { path } }) => (
  <LayoutWithStandardHeader>
    <MainHeader />
    <LayoutWithStandardHeader.Main>
      <Switch>
        <Route exact path="/">
          <Redirect to="/videos" replace />
        </Route>
        <Route exact path="/logged-out" component={RouteLoggedOut} />
        <EnsureSession>
          <Route path="/videos/:videoId" component={RouteVideo} />
          <Route exact path="/videos" component={RouteVideos} />
          <Route path="/redirects" component={RouteRedirect} />
        </EnsureSession>
      </Switch>
    </LayoutWithStandardHeader.Main>
    <MainFooter />
  </LayoutWithStandardHeader>
)

export default RouteApp



// WEBPACK FOOTER //
// ./src/routes/app.js